<template>
  <v-container class="fill-height"> </v-container>
</template>
<script>
export default {
  name: 'Logistics_dashboard'
}
</script>
